import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Forwards Angular-caught errors (component / template / RxJS, which Zone.js
 * intercepts before they reach window.onerror) to the Sentry/GlitchTip browser
 * SDK that is loaded + initialised by the build-time injection into index.html.
 *
 * Inert when the SDK isn't present (e.g. local dev) — the `if (s)` guard means
 * it simply falls through to console.error, so app behaviour is unchanged.
 */
@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    var s = (window as any).Sentry;
    if (s) { s.captureException((error && error.originalError) || error); }
    console.error(error); // unchanged: errors still surface in the console
  }
}
